// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container__ogplU {
  width: 100%;
  background-color: #f5fafa;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2rem 0 0 0;
}

.Header_headerContent__h\\+Fwg {
  width: 95%;
  display: flex;
  justify-content: space-between;
}

.Header_search__urVX4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 349px;
  height: 44px;
  padding: 0px 12px;
  border-radius: 8px;
  background-color: white;
}

.Header_search__urVX4 input {
  width: 100%;
  height: 32px;
  background-color: white;
  border: none;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.5%;

  &&:focus {
    outline: none;
  }
}

.Header_headerIcons__d-YrE {
  display: flex;
  gap: 16px;
}

.Header_headerIcons__d-YrE span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background-color: white;
  border-radius: 8px;
  cursor: pointer;
}

.Header_flagContainer__LgONZ {
  position: relative;
  display: flex;
  width: 44px;
  height: 44px;
  background-color: white;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
}

.Header_flagContainer__LgONZ img {
  cursor: pointer;
  width: 28px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;;EAEpB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":[".container {\r\n  width: 100%;\r\n  background-color: #f5fafa;\r\n  height: 80px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 2rem 0 0 0;\r\n}\r\n\r\n.headerContent {\r\n  width: 95%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.search {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 349px;\r\n  height: 44px;\r\n  padding: 0px 12px;\r\n  border-radius: 8px;\r\n  background-color: white;\r\n}\r\n\r\n.search input {\r\n  width: 100%;\r\n  height: 32px;\r\n  background-color: white;\r\n  border: none;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n  letter-spacing: 0.5%;\r\n\r\n  &&:focus {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.headerIcons {\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n\r\n.headerIcons span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 44px;\r\n  height: 44px;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.flagContainer {\r\n  position: relative;\r\n  display: flex;\r\n  width: 44px;\r\n  height: 44px;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.flagContainer img {\r\n  cursor: pointer;\r\n  width: 28px;\r\n  height: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__ogplU`,
	"headerContent": `Header_headerContent__h+Fwg`,
	"search": `Header_search__urVX4`,
	"headerIcons": `Header_headerIcons__d-YrE`,
	"flagContainer": `Header_flagContainer__LgONZ`
};
export default ___CSS_LOADER_EXPORT___;
